import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const CardBackfillRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment--card-backfill']}>
    <Route index element={<Index />} />
  </SubRouter>
))
